var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 1.33594C10.6479 1.33594 13.3359 4.02394 13.3359 7.33594C13.3359 10.6479 10.6479 13.3359 7.33594 13.3359C4.02394 13.3359 1.33594 10.6479 1.33594 7.33594C1.33594 4.02394 4.02394 1.33594 7.33594 1.33594ZM7.33594 12.0026C9.91394 12.0026 12.0026 9.91394 12.0026 7.33594C12.0026 4.75727 9.91394 2.66927 7.33594 2.66927C4.75727 2.66927 2.66927 4.75727 2.66927 7.33594C2.66927 9.91394 4.75727 12.0026 7.33594 12.0026ZM12.9926 12.0499L14.8786 13.9353L13.9353 14.8786L12.0499 12.9926L12.9926 12.0499V12.0499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a90cdea7e7376afe8e036b10f11c9347.svg";
export { ForwardRef as ReactComponent };